import { Container } from "../Container/Container";
import { List } from "../Container/List/List";
import { Anchor } from "../Anchor";
import { MenuItem } from "./MenuItem";
import { Div } from "../Div";
import { CFlexContainer } from "../Container/CFlexContainer";
import { toMap } from "../../../../HA";

export class AppMenu extends Container {
    public addItems(menuData: Map<any, any>[]): void {
        const items: List = this.getItemsContainer();
        items.clear();
        menuData.forEach((e: Map<string, string>) => {
            const a = new Anchor(toMap({
                d: JSON.stringify(e.get("d")),
                n: () => {
                    this.hide();
                },
                t: e.get("t"),
            }));
            a.appendChild(new MenuItem(e));
            items.addItem(a);
        });
    }

    private _returnFocus: HTMLElement | null = null;

    /**
     * HA-268 — accès clavier : à l'ouverture le focus va sur la première entrée
     * (sinon il reste derrière l'overlay), Échap ferme, et la fermeture rend le
     * focus à l'élément qui avait ouvert le menu.
     */
    public show(): void {
        const active = document.activeElement;
        this._returnFocus = active instanceof HTMLElement ? active : null;
        super.show();
        const first = (this.getElement() as HTMLElement | null)?.querySelector<HTMLElement>(".menus a");
        first?.focus();
    }

    public hide(defaut?: any): void {
        super.hide(defaut);
        const back = this._returnFocus;
        this._returnFocus = null;
        if (back && back.isConnected) { back.focus(); }
    }

    protected getItemsContainer(): List {
        return this.get("items");
    }

    protected initialize(data: any) {
        super.initialize(data);
        const itemsContainer = new List({tag: new CFlexContainer({class: "menus"})});
        const ic = new Div({classes: ["menupane", "ic"]});
        ic.appendChild(itemsContainer);
        this.appendChild(ic);
        this.addClass("overlay");
        this.addClass("active");
        this.addToData("items", itemsContainer);
        this.onClick(() => {
            this.hide();
        });
        (this.getElement() as HTMLElement | null)?.addEventListener("keydown", (event: KeyboardEvent) => {
            if (event.key === "Escape") { event.preventDefault(); this.hide(); }
        });
    }
}
